import { render, staticRenderFns } from "./globalMaterialsModal.vue?vue&type=template&id=e5a0dd28"
import script from "./globalMaterialsModal.vue?vue&type=script&lang=js"
export * from "./globalMaterialsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports